import { InvoiceRequest, VatId } from "../ordering";
export const INVOICE_DETAILS_KEY = "client_invoiceDetails";
export class InvoiceDetailsStorageManager {
    store(invoiceRequest) {
        let invoiceDetailsData;
        if (invoiceRequest == null) {
            invoiceDetailsData = {
                isInvoiceNeeded: false,
                vatId: "",
            };
        }
        else {
            invoiceDetailsData = {
                isInvoiceNeeded: true,
                vatId: invoiceRequest.vatId.value,
            };
        }
        const invoiceDetailsDataString = JSON.stringify(invoiceDetailsData);
        localStorage.setItem(INVOICE_DETAILS_KEY, invoiceDetailsDataString);
    }
    restore() {
        const invoiceDetailsDataString = localStorage.getItem(INVOICE_DETAILS_KEY);
        if (invoiceDetailsDataString === null) {
            return null;
        }
        const invoiceDetailsData = JSON.parse(invoiceDetailsDataString);
        if (!invoiceDetailsData.isInvoiceNeeded) {
            return null;
        }
        return new InvoiceRequest({
            vatId: new VatId(invoiceDetailsData.vatId),
        });
    }
}
